export default {
  demande: {
    creation: {
      personnePhysique: 'Demande de création de personne physique',
      personneMorale: 'Demande de création de personne morale',
    },
  },
  creationDemande: {
    title: 'Demande de création',
  },
  creationPhysique: {
    blocInformation: 'Bloc Informations Générales',
    blocCoordonnees: 'Bloc Coordonnées Principales',
    informationsMorales: 'Informations Personne Morale',
    natureContact: 'Nature Du Contact',
    contactAbsence: 'Contact En Cas Absence',
    accesautorise: 'Accès Autorisés :',
  },
  creationMorale: {
    blocInformationGenerale: 'Bloc Informations Générales',
    blocInformationStructure: 'Bloc Informations de Structure',
    cotisations: 'Cotisations',
    coordonnees: 'Coordonnées',
  },
};
